import * as React from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'

import { Icon } from '@wartek-id/icon'
import { historyUtils } from '@wartek-id/toolbox-helper'

import AndroidHandler from 'utils/androidHandler'
import PacketListsPage from 'app/AssessmentPage/Packets/PacketLists'
import { Header } from 'components/Header'
import BottomNav from 'app/AssessmentPage/components/BottomNav'

const title = 'Pilih AKM Kelas'

const AssesmentSelect = () => {
  const router = useRouter()
  const androidHandler = AndroidHandler()

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <Header
        className="border-none"
        iconLeftSrc="/icon/arrow-left-white.svg"
        hasBackButton
        title={title}
        variant="darkBlue"
        rightChild={
          <Icon as="i" color="inverse">
            help
          </Icon>
        }
        onLeftActionClick={() => {
          if (androidHandler.enabled) historyUtils.backToApp(router.back)
          else router.back()
        }}
        onRightActionClick={() => {
          window.location.href =
            process.env.NEXT_PUBLIC_PUSAT_INFORMASI_RUMDIK_BASE_URL +
            '/hc/id/sections/52398093679001-Asesmen-Murid'
        }}
      />
      <PacketListsPage />
      <BottomNav />
    </>
  )
}

export default AssesmentSelect
